module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_09-a0c7119f9e677afe68ddd7c575e1fd1e.jpg";